import { useState, useEffect } from "react";
import axios from "axios";
import toastError from "../../errors/toastError";

import api from "../../services/api";

const useTickets = ({
  searchParam,
  tags,
  users,
  contactIds,
  osTerceiroIds,
  pageNumber,
  status,
  date,
  updatedAt,
  showAll,
  queueIds,
  withUnreadMessages,
  enabled = true,
}) => {
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [loadedKey, setLoadedKey] = useState("");

  const requestKey = JSON.stringify({
    searchParam,
    tags,
    users,
    contactIds,
    osTerceiroIds,
    pageNumber,
    status,
    date,
    updatedAt,
    showAll,
    queueIds,
    withUnreadMessages,
  });

  useEffect(() => {
    const cancelSource = axios.CancelToken.source();
    let cancelled = false;

    setLoading(enabled);
    if (pageNumber === 1) {
      setTickets([]);
      setHasMore(false);
    }

    if (!enabled) {
      setLoadedKey(requestKey);
      return () => cancelSource.cancel();
    }

    const fetchTickets = async () => {
      try {
        const { data } = await api.get("/tickets", {
          cancelToken: cancelSource.token,
          params: {
            searchParam,
            pageNumber,
            tags,
            users,
            contactIds,
            osTerceiroIds,
            status,
            date,
            updatedAt,
            showAll,
            queueIds,
            withUnreadMessages,
          },
        });

        if (cancelled) return;

        setTickets(data.tickets);
        setHasMore(data.hasMore);
        setLoadedKey(requestKey);
        setLoading(false);
      } catch (err) {
        if (axios.isCancel(err) || cancelled) return;
        setLoading(false);
        toastError(err);
      }
    };

    fetchTickets();

    return () => {
      cancelled = true;
      cancelSource.cancel();
    };
  }, [
    searchParam,
    tags,
    users,
    contactIds,
    osTerceiroIds,
    pageNumber,
    status,
    date,
    updatedAt,
    showAll,
    queueIds,
    withUnreadMessages,
    enabled,
    requestKey,
  ]);

  return { tickets, loading, hasMore, requestKey, loadedKey };
};

export default useTickets;
